import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Select } from '@/components/ui/select'

import { LINK_STYLES, LinkStyle } from './linked-columns.constants'

interface LinkStyleSelectProps {
  value: LinkStyle
  onChange: (value: LinkStyle) => void
}

// Note: the select's trigger is transparent by default, which blends into the page header
const Wrapper = styled.div(({ theme }) => ({
  'button[type="button"]': {
    backgroundColor: theme.colors.white,
  },
  display: 'contents',
}))

export const LinkStyleSelect = ({ value, onChange }: LinkStyleSelectProps) => {
  const { t } = useTranslation('common')

  return (
    <Wrapper>
      <Select
        label={t('linkedColumns.linkStyle')}
        options={LINK_STYLES.map((style) => ({
          label: t(`linkedColumns.styles.${style}`),
          value: style,
        }))}
        size="small"
        value={value}
        onChange={onChange}
      />
    </Wrapper>
  )
}
